import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createDragDropManager } from 'dnd-core';

const DNDManager = createDragDropManager(HTML5Backend);

export const GlobalDndContext = (props) =>
{
   return <DndProvider manager={DNDManager}>{props.children}</DndProvider>
}

export default GlobalDndContext;